import angular from 'angular';
import constants from 'app/constants';
import { alerts } from 'app/components/global';
import IComplianceAppDataService from './IComplianceApp.data.service';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

let _alerts; // TODO: remove this and the reference to never used .ashx file below.

class cmDataService extends IComplianceAppDataService {
  constructor(
    $http,

    alerts, // eslint-disable-line no-shadow
    utilityService // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'cm');
    _alerts = alerts;

    this.cache = {};
    console.log('app.services.cmDataService created');
  }

  // ///////////// Committees ///////////////////
  getCommittees() {
    return this.$http({
      url: `${this.apiRootUrl}cm/committee/`,
      method: 'GET',
    });
  }

  getCommittee(committeeId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/committee/${committeeId}`,
      method: 'GET',
    });
  }

  saveCommittee(committee) {
    if (committee.committeeId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/committee/${committee.committeeId}`,
        method: 'PUT',
        data: this.serializeData({
          committee: JSON.stringify(committee),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/committee`,
      method: 'POST',
      data: this.serializeData({
        committee: JSON.stringify(committee),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteCommittee(committeeId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/committee/${committeeId}`,
      method: 'DELETE',
    });
  }


  // ///////////// Meetings ///////////////////

  getMeetingsByCommittee(committeeId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/committee/${committeeId}/meeting`,
      method: 'GET',
    });
  }

  getOtherMeetingsByCommittee(committeeId, meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/committee/${committeeId}/meetingOtherThan/${meetingId}`,
      method: 'GET',
    });
  }

  getMeeting(meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meeting/${meetingId}`,
      method: 'GET',
    });
  }

  checkMeetingExists(name, committeeId, meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meeting/checkExists`,
      method: 'GET',
      params: {
        name,
        committeeId,
        meetingId,
      }
    });
  }

  saveMeeting(meeting) {
    if (meeting.meetingId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/meeting/${meeting.meetingId}`,
        method: 'PUT',
        data: this.serializeData({
          meeting: JSON.stringify(meeting),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/meeting`,
      method: 'POST',
      data: this.serializeData({
        meeting: JSON.stringify(meeting),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteMeeting(meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meeting/${meetingId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Agenda Items ////////////////////

  getDefaultAgendaItem(meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meeting/${meetingId}/getDefaultAgendaItem`,
      method: 'GET',
    });
  }

  getAgendaItemsByMeeting(meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meeting/${meetingId}/agendaItem`,
      method: 'GET',
    });
  }

  getAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem/${agendaItemId}`,
      method: 'GET',
    });
  }

  getFullAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem/${agendaItemId}`,
      method: 'GET',
    });
  }

  saveAgendaItems(meeting) { // eslint-disable-line no-unused-vars
    /*
        if (agendaItem.agendaItemId > 0) {
          return this.$http({
            url: this.apiRootUrl + '/cm/agendaItem/' + agendaItem.agendaItemId,
            method: 'PUT',
            data: this.serializeData({
              preparationItem: JSON.stringify(agendaItem),
              echo: true,
            }),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          });
        } else {
          return this.$http({
            url: this.apiRootUrl + '/cm/agendaItem',
            method: 'POST',
            data: this.serializeData({
              preparationItem: JSON.stringify(agendaItem),
              echo: true,
            }),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          });
        }
    */
  }

  saveAgendaItem(agendaItem) {
    if (agendaItem.agendaItemId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/agendaItem/${agendaItem.agendaItemId}`,
        method: 'PUT',
        data: this.serializeData({
          agendaItem: JSON.stringify(agendaItem),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem`,
      method: 'POST',
      data: this.serializeData({
        agendaItem: JSON.stringify(agendaItem),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem/${agendaItemId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Agenda Item Notes ////////////////////

  getAgendaItemNotes(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem/${agendaItemId}/note`,
      method: 'GET',
    });
  }

  getAgendaItemNote(agendaItemNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItemNote/${agendaItemNoteId}`,
      method: 'GET',
    });
  }

  saveAgendaItemNote(agendaItemId, agendaItemNoteId, agendaItemNoteText) {
    if (agendaItemNoteId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/agendaItemNote/${agendaItemNoteId}`,
        method: 'PUT',
        data: this.serializeData({
          agendaItemNoteId,
          agendaItemId,
          agendaItemNoteText: JSON.stringify(agendaItemNoteText),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItemNote`,
      method: 'POST',
      data: this.serializeData({
        agendaItemNoteId,
        agendaItemId,
        agendaItemNoteText: JSON.stringify(agendaItemNoteText),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteAgendaItemNote(agendaItemNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItemNote/${agendaItemNoteId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Agenda Item Documents ////////////////////

  getAgendaItemDocument(agendaItemDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItemDocument/${agendaItemDocumentId}`,
      method: 'GET',
    });
  }

  getAgendaItemDocumentsByFolder(folderId) {
    return this.$http({
      url: `${this.apiRootUrl}cm/folder/${folderId}/agendaItemDocument`,
      method: 'GET',
    });
  }

  getAgendaItemDocuments(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}cm/agendaItem/${agendaItemId}/document`,
      method: 'GET',
    });
  }

  attachAgendaItemDocument(agendaItemId, documentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agendaItem/${agendaItemId}/attachDocument/${documentId}`,
      method: 'POST',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachAgendaItemDocument(agendaItemDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agendaItemDocument/${agendaItemDocumentId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Agenda Item Reports ////////////////////

  getAgendaItemReport(agendaItemReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItemReport/${agendaItemReportInstanceId}`,
      method: 'GET',
    });
  }

  getAgendaItemReports(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}cm/agendaItem/${agendaItemId}/report`,
      method: 'GET',
    });
  }

  attachAgendaItemReport(agendaItemId, reportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agendaItem/${agendaItemId}/attachReport/${reportInstanceId}`,
      method: 'POST',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachAgendaItemReport(agendaItemReportInstanceId) {
    return this.$http({
      url: `${this.apiRootUrl}/am/agendaItemReport/${agendaItemReportInstanceId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Discussion Points ////////////////////

  getDefaultDiscussionPoint(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem/${agendaItemId}/getDefaultDiscussionPoint`,
      method: 'GET',
    });
  }

  getDiscussionPointsByAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}cm/agendaItem/${agendaItemId}/discussionPoint`,
      method: 'GET',
    });
  }

  getDiscussionPoint(discussionPointId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/discussionPoint/${discussionPointId}`,
      method: 'GET',
    });
  }

  saveDiscussionPoint(discussionPoint) {
    if (discussionPoint.discussionPointId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/discussionPoint/${discussionPoint.discussionPointId}`,
        method: 'PUT',
        data: this.serializeData({
          discussionPoint: JSON.stringify(discussionPoint),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItemNote`,
      method: 'POST',
      data: this.serializeData({
        discussionPoint: JSON.stringify(discussionPoint),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteDiscussionPoint(discussionPointId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/discussionPoint/${discussionPointId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Discussion Point Notes ////////////////////

  getDiscussionPointNotes(discussionPointId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/discussionPoint/${discussionPointId}/note`,
      method: 'GET',
    });
  }

  getDiscussionPointNote(discussionPointNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/discussionPointNote/${discussionPointNoteId}`,
      method: 'GET',
    });
  }

  saveDiscussionPointNote(discussionPointId, discussionPointNoteId, discussionPointNoteText) {
    if (discussionPointNoteId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/discussionPointNote/${discussionPointNoteId}`,
        method: 'PUT',
        data: this.serializeData({
          discussionPointNoteId,
          discussionPointId,
          discussionPointNoteText: JSON.stringify(discussionPointNoteText),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/discussionPointNote`,
      method: 'POST',
      data: this.serializeData({
        discussionPointNoteId,
        discussionPointId,
        discussionPointNoteText: JSON.stringify(discussionPointNoteText),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deletediscussionPointNote(discussionPointNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/discussionPointNote/${discussionPointNoteId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Followup Items ////////////////////
  getDefaultFollowupItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem/${agendaItemId}/getDefaultFollowupItem`,
      method: 'GET',
    });
  }

  getFollowupItemsByAgendaItem(agendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/agendaItem/${agendaItemId}/followupItem`,
      method: 'GET',
    });
  }

  getFollowupItem(followupItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItem/${followupItemId}`,
      method: 'GET',
    });
  }

  saveFollowupItem(followupItem) {
    if (followupItem.followupItemId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/followupItem/${followupItem.followupItemId}`,
        method: 'PUT',
        data: this.serializeData({
          followupItem: JSON.stringify(followupItem),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItem`,
      method: 'POST',
      data: this.serializeData({
        followupItem: JSON.stringify(followupItem),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteFollowupItem(followupItem) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItem/${followupItem}`,
      method: 'DELETE',
    });
  }

  // ///////////// Followup Item Notes ////////////////////

  getFollowupItemNotes(followupItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItem/${followupItemId}/note`,
      method: 'GET',
    });
  }

  getFollowupItemNote(followupItemNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItemNote/${followupItemNoteId}`,
      method: 'GET',
    });
  }

  saveFollowupItemNote(followupItemId, followupItemNoteId, followupItemNoteText) {
    if (followupItemNoteId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/followupItemNote/${followupItemNoteId}`,
        method: 'PUT',
        data: this.serializeData({
          followupItemNoteId,
          followupItemId,
          followupItemNoteText: JSON.stringify(followupItemNoteText),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItemNote`,
      method: 'POST',
      data: this.serializeData({
        followupItemNoteId,
        followupItemId,
        followupItemNoteText: JSON.stringify(followupItemNoteText),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deletefollowupItemNote(followupItemNoteId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItemNote/${followupItemNoteId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Meeting Package ///////////////////

  generateMeetingPackageFileList(meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}cm/meeting/${meetingId}/generateMeetingPackageFileList`,
      method: 'POST',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  createMeetingPackageFileGenerationRequest(meetingId) {
    return this.$http({
      url: `${this.apiRootUrl}cm/meeting/${meetingId}/generateMeetingPackage`,
      method: 'POST',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // ///////////// Meeting Templates ////////////////////

  getMeetingTemplatesByCustomer(customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/customer/${customerId}/meetingTemplate`,
      method: 'GET',
    });
  }

  getActiveMeetingTemplates() {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplate/getActive`,
      method: 'GET',
    });
  }

  getMeetingTemplate(meetingTemplateId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplate/${meetingTemplateId}`,
      method: 'GET',
    });
  }

  saveMeetingTemplate(meetingTemplate) {
    if (meetingTemplate.meetingTemplateId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/meetingTemplate/${meetingTemplate.meetingTemplateId}`,
        method: 'PUT',
        data: this.serializeData({
          meetingTemplate: JSON.stringify(meetingTemplate),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplate`,
      method: 'POST',
      data: this.serializeData({
        meetingTemplate: JSON.stringify(meetingTemplate),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteMeetingTemplate(meetingTemplateId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplate/${meetingTemplateId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Meeting Template Agenda Items ////////////////////

  getMeetingTemplateAgendaItemsByMeetingTemplate(meetingTemplateId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplate/${meetingTemplateId}/meetingTemplateAgendaItem`,
      method: 'GET',
    });
  }

  getMeetingTemplateAgendaItem(meetingTemplateAgendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplateAgendaItem/${meetingTemplateAgendaItemId}`,
      method: 'GET',
    });
  }

  saveMeetingTemplateAgendaItem(meetingTemplateAgendaItem) {
    if (meetingTemplateAgendaItem.meetingTemplateAgendaItemId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/cm/meetingTemplate/${meetingTemplateAgendaItem.meetingTemplateAgendaItemId}`,
        method: 'PUT',
        data: this.serializeData({
          meetingTemplateAgendaItem: JSON.stringify(meetingTemplateAgendaItem),
          echo: true,
        }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplate`,
      method: 'POST',
      data: this.serializeData({
        meetingTemplateAgendaItem: JSON.stringify(meetingTemplateAgendaItem),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteMeetingTemplateAgendaItem(meetingTemplateAgendaItemId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingTemplateAgendaItem/${meetingTemplateAgendaItemId}`,
      method: 'DELETE',
    });
  }

  // ///////////// Supporting Entities ///////////////////

  getMeetingTypes() {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingType`,
      method: 'GET',
    });
  }

  getMeetingType(meetingTypeId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/meetingType/${meetingTypeId}`,
      method: 'GET',
    });
  }

  getFollowupItemStatuses() {
    return this.$http({
      url: `${this.apiRootUrl}/cm/followupItemStatus`,
      method: 'GET',
    });
  }

  // ///////////// Reports ///////////////////

  generateFullReport(assessmentId, name, reportSection, renderFullReport, saveDocument, cookieName) {
    const $frmDownloadFile = angular.element(
      '<form'
      + ' id="frmDownloadFile"'
      + ' method="post"'
      + ' target="ifrmDownloadFile">'
      + '</form>'
    ).appendTo(angular.element('#ifrmDownloadFile'));
    // $frmDownloadFile.attr(
    //   'action',
    //   `${_paths.directories.handlers.root}cm/CMReportHandler.ashx`
    // );
    $frmDownloadFile.append(angular.element(
      '<input'
      + ' type="hidden"'
      + ' name="action" />'
    ).val('generateFullReport'));
    $frmDownloadFile.append(angular.element(
      '<input'
      + ' type="hidden"'
      + ' name="assessmentId" />'
    ).val(assessmentId));
    $frmDownloadFile.append(angular.element(
      '<input'
      + ' type="hidden"'
      + ' name="name" />'
    ).val(name));
    $frmDownloadFile.append(angular.element(
      '<input'
      + ' type="hidden"'
      + ' name="reportSection" />'
    ).val(reportSection));
    $frmDownloadFile.append(angular.element(
      '<input'
      + ' type="hidden"'
      + ' name="renderFullReport" />'
    ).val(renderFullReport));
    $frmDownloadFile.append(angular.element(
      '<input'
      + ' type="hidden"'
      + ' name="saveDocument" />'
    ).val(saveDocument));
    $frmDownloadFile.append(angular.element(
      '<input'
      + ' type="hidden"'
      + ' name="amCookieName" />'
    ).val(cookieName));
    $frmDownloadFile.submit();
    _alerts.success(copy.cmReports.alerts.generatingReport.text);
  }

  // TODO: CONVERT ALL THESE TO NEW API
  // ///// Import //////////

  // ///// Import Preparation Items //////////
  stagePreparationItemsImportData(customerId, auditId, bankName, fileName, uploadType) {
    return this.$http.post(`${this.apiRootUrl}/cm/PreparationItems/Import/stageImportData.ashx`, {}, {
      params: {
        customerId,
        auditId,
        bankName,
        fileName,
        uploadType
      }
    });
  }

  processPreparationItemsImport(preparationItemImportSetId) {
    return this.$http.post(`${this.apiRootUrl}/cm/PreparationItems/Import/processImport.ashx`, {}, {
      params: {
        preparationItemImportSetId
      }
    });
  }

  getPreparationItemsImportDetails(preparationItemImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/PreparationItems/Import/getImportDetails.ashx`,
      method: 'GET',
      params: {
        preparationItemImportSetId
      }
    });
  }

  getPreparationItemsImportHeaders(preparationItemImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/PreparationItems/Import/getImportHeaders.ashx`,
      method: 'GET',
      params: {
        preparationItemImportSetId
      }
    });
  }

  getPreparationItemsImportMappings(preparationItemImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/PreparationItems/Import/PreparationItemImportSetMapping`,
      method: 'GET',
      params: {
        action: 'getByPreparationItemImportSet',
        preparationItemImportSetId,
      }
    });
  }

  savePreparationItemsImportMappings(mappings) {
    return this.$http.post(`${this.apiRootUrl}/cm/PreparationItems/Import/PreparationItemImportSetMapping`,
      { mappings }, {
        params: {
          action: 'save',
        }
      });
  }

  getPreparationItemImportTemplateFile(networkPath, storeRootKey, fileType, fileName) {
    const url = `${this.apiRootUrl}/cm/${networkPath}/import/handleImportFile.ashx`;
    // ?storeRootKey=' + storeRootKey + '&fileType=' + fileType + '&f=' + fileName;

    const $frmDownloadFile = angular.element(
      '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo(angular.element('#ifrmDownloadFile'));
    $frmDownloadFile.attr('action', url);
    $frmDownloadFile.append(angular.element('<input type="hidden" name="storeRootKey" />').val(storeRootKey));
    $frmDownloadFile.append(angular.element('<input type="hidden" name="fileType" />').val(fileType));
    $frmDownloadFile.append(angular.element('<input type="hidden" name="f" />').val(fileName));
    $frmDownloadFile.submit();
    _alerts.success(copy.amReports.alerts.downloadTemplate.text);
  }

  // ///// Import Findings //////////
  stageFindingsImportData(customerId, auditId, bankName, fileName, uploadType) {
    return this.$http.post(`${this.apiRootUrl}/cm/Findings/Import/stageImportData.ashx`, {}, {
      params: {
        customerId,
        auditId,
        bankName,
        fileName,
        uploadType
      }
    });
  }

  processFindingsImport(findingImportSetId) {
    return this.$http.post(`${this.apiRootUrl}/cm/Findings/Import/processImport.ashx`, {}, {
      params: {
        findingImportSetId
      }
    });
  }

  getFindingsImportDetails(findingImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/Findings/Import/getImportDetails.ashx`,
      method: 'GET',
      params: {
        findingImportSetId
      }
    });
  }

  getFindingsImportHeaders(findingImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/Findings/Import/getImportHeaders.ashx`,
      method: 'GET',
      params: {
        findingImportSetId
      }
    });
  }

  getFindingsImportMappings(findingImportSetId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/Findings/Import/FindingImportSetMapping`,
      method: 'GET',
      params: {
        action: 'getByFindingImportSet',
        findingImportSetId,
      }
    });
  }

  saveFindingsImportMappings(mappings) {
    return this.$http.post(`${this.apiRootUrl}/cm/Findings/Import/FindingImportSetMapping`, { mappings }, {
      params: {
        action: 'save',
      }
    });
  }

  // ///// General Import //////////
  getImportTemplateFile(auditId, networkPath) {
    const url = `${this.apiRootUrl}/cm/${networkPath}/Import/handleImportFile.ashx`;

    const $frmDownloadFile = angular.element(
      '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo(angular.element('#ifrmDownloadFile'));
    $frmDownloadFile.attr('action', url);
    $frmDownloadFile.append(angular.element('<input type="hidden" name="auditId" />').val(auditId));
    $frmDownloadFile.submit();
    _alerts.success(copy.amReports.alerts.downloadTemplate.text);
  }

  // ///// General General Download Package //////////
  downloadPackage(meetingPackageId) {
    return this.$http({
      url: `${this.apiRootUrl}/cm/LargeFile`,
      method: 'GET',
      params: {
        meetingPackageId
      },
    })
      .success((data, status, headers) => { // eslint-disable-line
        const abcd = 1;// eslint-disable-line
      })
      .catch((data) => {// eslint-disable-line
        const abcd = 1;// eslint-disable-line
      });
  }
}


cmDataService.$inject = ['$http', 'alerts', 'utilityService'];

export default angular.module('app.services.cmDataService', [
  constants,
  alerts,
])
  .service('cmDataService', cmDataService)
  .name;
